

import Prototypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getImageSrc } from '../../utils/imageUrl';

export default function OrderItems({ orderItems }) {
  return (
    <div className="order order-body">
      <h2>Order Items</h2>
      <ul>
        {orderItems.map(item => (
          <li key={item.product}>
            <div className="product">
              <div>
                <img src={getImageSrc(item.imagen)} alt={item.name} className="small" />
              </div>
              <div className="min-30">
                <Link to={`/product/${item.product}`}>{item.name}</Link>
              </div>
              <div>
                {item.qty} x ${item.price} = $
                {(item.qty * item.price).toFixed(2)}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

OrderItems.prototypes = {
  orderItems: Prototypes.arrayOf(
    Prototypes.shape({
      product: Prototypes.string.isRequired,
      imagen: Prototypes.string.isRequired,
      name: Prototypes.string.isRequired,
      qty: Prototypes.number.isRequired,
      price: Prototypes.number.isRequired,
    })
  ).isRequired,
};
